export default __webpack_public_path__ + "static/media/IMG_4577-min.435126d1.JPG";